"use client";
import {NeoButton, NeoDatePicker, NeoSelect} from "@/components/forms";
//import {UsersFilterConfig} from "@/data/users/filter.config";
import {useNeoContext} from "@/context/neo/neo.context";
import {Chip, Image, SelectItem, Switch} from "@nextui-org/react";
import {ChangeEvent, useEffect, useMemo, useState} from "react";
import {useForm} from "react-hook-form";
/**
 * TODO: @selva,@surya,@arun
 * Create a Validation Schema if you have a form & inject them
 */
export const DashboardReportFilter: React.FC<DashboardReportsFilterProps> = ({
  onSubmit,
  activeFilters,
  oldFilter,
  innerFilters
}) => {
  const reportFilterConfig = {
    mainFilter: [
      {
        label: "Today",
        value: "1"
      },
      {
        label: "Yesterday",
        value: "2"
      },
      {
        label: "Current Week",
        value: "3"
      },
      {
        label: "Last Week",
        value: "4"
      },
      {
        label: "Current Month",
        value: "5"
      },
      {
        label: "Last Month",
        value: "6"
      },
      {
        label: "Range",
        value: "7"
      }
    ],
    thresholdList: [
      {
        label: "> 50",
        value: 50
      },
      {
        label: "> 60",
        value: 60
      },
      {
        label: "> 70",
        value: 70
      }
    ],
    //Status : 1 - Yet to start, 2 - In progress, 3 - Completed, 4 - Not completed

    tripStatus: [
      {
        label: "Yet to start",
        value: 1
      },
      {
        label: "In progress",
        value: 2
      },
      {
        label: "Completed",
        value: 3
      },
      {
        label: "Not completed",
        value: 4
      }
    ]
  };

  const {register, handleSubmit, setValue} = useForm();
  const {vehicles} = useNeoContext();
  const [selectedDateRange, setSelectedDateRange] = useState<DateRange>({
    from: null,
    to: null
  });
  const getValidDateRange = () => {
    if (!oldFilter?.from || !oldFilter?.to) {
      return null;
    }

    const fromDate = new Date(oldFilter.from);
    const toDate = new Date(oldFilter.to);

    if (Number.isNaN(fromDate.getTime()) || Number.isNaN(toDate.getTime())) {
      return null;
    }

    return {
      from: fromDate,
      to: toDate
    };
  };
  const [selectedFilterType, setSelectedFilterType] = useState("1");
  // const [selectedFilterVehicleOne, setSelectedFilterVehicleOne] = useState();

  const [showDateRange, setShowDateRange] = useState(false);
  //advanced filters start
  const [selectedFilters, setSelectedFilters] = useState<{
    [key: string]: number[];
  }>({});

  // Step 1: Initialize with default values
  useEffect(() => {
    if (innerFilters) {
      const initialFilters: {[key: string]: number[]} = {};
      innerFilters.forEach((filter: any) => {
        initialFilters[filter.uid] =
          oldFilter.filters[filter.uid] || filter.defaultValue || [];
      });
      setSelectedFilters(initialFilters);
    }
  }, [innerFilters]);

  useEffect(() => {
    const initialFilterType =
      oldFilter?.filterType
        ? String(oldFilter.filterType)
        : oldFilter?.from && oldFilter?.to
          ? "7"
          : "1";

    setSelectedFilterType(initialFilterType);
    setValue("filterType", initialFilterType);

    if (initialFilterType !== "7") {
      setShowDateRange(false);
      return;
    }

    const range = getValidDateRange();
    if (!range) {
      return;
    }

    setShowDateRange(true);
    setSelectedDateRange(range);
  }, [oldFilter?.filterType, oldFilter?.from, oldFilter?.to, setValue]);

  // Step 2: Toggle logic for multiSelect
  const toggleMultiSelect = (uid: string, id: number) => {
    setSelectedFilters(prev => {
      const current = prev[uid] || [];
      const updated = current.includes(id)
        ? current.filter(i => i !== id)
        : [...current, id];
      return {...prev, [uid]: updated};
    });
  };

  // Step 3: Toggle logic for switch
  const toggleSwitch = (uid: string, id: number, checked: boolean) => {
    setSelectedFilters(prev => ({
      ...prev,
      [uid]: checked ? [id] : []
    }));
  };

  //advanced filters end
  const resetFiltervalue = (filter: number) => {
    if (filter === 1) {
      // filter Type
      if (oldFilter.filterType) {
        if (oldFilter.filterType == 7) {
          //range
          setShowDateRange(true);
          const range = getValidDateRange();
          if (range) {
            setSelectedDateRange(range);
          }
        } else {
          handleFromToFilterData(oldFilter.filterType);
        }
        return oldFilter.filterType;
      } else {
        handleFromToFilterData("1");
        return "1";
      }
    }
    if (filter === 2) {
      // Vehicle Single Filter
      if (oldFilter.trackerId) {
        return oldFilter.trackerId;
      } else {
        return vehicles[0].trackerId;
      }
    }
    if (filter === 4) {
      const range = getValidDateRange();
      if (range) {
        setSelectedDateRange(range);
        return range.from;
      }
      return new Date();
    }
    if (filter === 5) {
      if (oldFilter.threshold) {
        return oldFilter.threshold;
      } else {
        return "60";
      }
    }
  };

  const handleFilterTypeChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const filterType = e.target.value;
    setSelectedFilterType(filterType);
    setShowDateRange(false);
    handleFromToFilterData(filterType);
    //setSelectedFilterType(filterType);
    setValue("filterType", filterType);
  };

  const handleFromToFilterData = (filterType: any) => {
    const currentDate = new Date();
    if (filterType === "1") {
      //Today
      const fromDate = new Date(currentDate);
      const toDate = new Date(currentDate);
      fromDate.setHours(0, 0, 0, 0);
      toDate.setHours(23, 59, 59, 999);
      const selectedDateRangeVal = {
        from: fromDate,
        to: toDate
      };

      setSelectedDateRange(selectedDateRangeVal);
    } else if (filterType === "2") {
      //Yesterday
      const fromDate = new Date(currentDate);
      fromDate.setDate(currentDate.getDate() - 1);
      const toDate = new Date(currentDate);
      toDate.setDate(currentDate.getDate() - 1);

      fromDate.setHours(0, 0, 0, 0);
      toDate.setHours(23, 59, 59, 999);

      const selectedDateRange = {
        from: fromDate,
        to: toDate
      };
      setSelectedDateRange(selectedDateRange);
    } else if (filterType === "3" || filterType === "4") {
      //current and last week
      const dayOfWeek = currentDate.getDay(); // 0 (Sun) - 6 (Sat)
      const diffToMonday = (dayOfWeek + 6) % 7; // Days since last Monday
      // Current week
      const currentWeekFrom = new Date(currentDate);
      currentWeekFrom.setDate(currentDate.getDate() - diffToMonday);
      currentWeekFrom.setHours(0, 0, 0, 0);

      const currentWeekTo = new Date(currentWeekFrom);
      currentWeekTo.setDate(currentWeekFrom.getDate() + 6);
      currentWeekTo.setHours(23, 59, 59, 999);

      //current week shouldnot end last day of the week
      const currentWeekTodayTo = new Date(currentDate);
      currentWeekTodayTo.setHours(23, 59, 59, 999);

      // Last week
      const lastWeekFrom = new Date(currentWeekFrom);
      lastWeekFrom.setDate(currentWeekFrom.getDate() - 7);

      const lastWeekTo = new Date(currentWeekTo);
      lastWeekTo.setDate(currentWeekTo.getDate() - 7);

      if (filterType === "3") {
        //current week
        const selectedDateRange = {
          from: currentWeekFrom,
          to: currentWeekTodayTo
        };
        setSelectedDateRange(selectedDateRange);
      } else if (filterType === "4") {
        //lastweek
        const selectedDateRange = {
          from: lastWeekFrom,
          to: lastWeekTo
        };
        setSelectedDateRange(selectedDateRange);
      }
    } else if (filterType === "5") {
      //current month
      const currentMonthFrom = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1
      );
      const currentMonthTo = new Date(currentDate);
      currentMonthTo.setHours(23, 59, 59, 999);
      const selectedDateRange = {
        from: currentMonthFrom,
        to: currentMonthTo
      };
      setSelectedDateRange(selectedDateRange);
    } else if (filterType === "6") {
      //last month
      const lastMonthFrom = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - 1,
        1
      );
      const lastMonthTo = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        0
      );
      lastMonthTo.setHours(23, 59, 59, 999);
      const selectedDateRange = {
        from: lastMonthFrom,
        to: lastMonthTo
      };
      setSelectedDateRange(selectedDateRange);
    } else if (filterType === "7") {
      //selected range
      setShowDateRange(true);
      setSelectedFilterType("7");
      return;
    }
    setSelectedFilterType(String(filterType));
  };
  // Memoize default values for the filters to avoid recomputation on each render
  const defaultFilterType = useMemo(
    () => resetFiltervalue(1),
    [oldFilter?.filterType, oldFilter?.from, oldFilter?.to]
  );
  const defaultVehicleSingle = useMemo(() => resetFiltervalue(2), []);
  const defaultVehicleMultiple = useMemo(() => resetFiltervalue(3), []);
  const defaultSingleDate = useMemo(
    () => resetFiltervalue(4),
    [oldFilter?.from, oldFilter?.to]
  );
  const defaultThreshold = useMemo(() => resetFiltervalue(5), []);

  useEffect(() => {
    setSelectedFilterType(String(defaultFilterType));
  }, [defaultFilterType]);

  const onDateChange = (event: any) => {
    setSelectedDateRange(event);
  };
  //const tripTypeStatussetDropdown = () => [1, 2, 3, 4];
  const tripTypeStatussetDropdown: number[] = [1, 2, 3];

  const onSingleDateChange = (event: any) => {
    event.setHours(0, 0, 0, 0);
    event.setHours(23, 59, 59, 999);
    event.from = event.getTime();
    event.to = event.getTime();
    setSelectedDateRange(event);
  };
  const onSubmitEvent = (event: any) => {
    //handle Filter functionality
    event.filterType = selectedFilterType;
    event.filters = selectedFilters;
    if (selectedDateRange.from && selectedDateRange.to) {
      const fromDate = new Date(selectedDateRange.from);
      const toDate = new Date(selectedDateRange.to);
      fromDate.setHours(0, 0, 0, 0);
      toDate.setHours(23, 59, 59, 999);
      event.from = fromDate.getTime();
      event.to = toDate.getTime();
    }
    if (Object.prototype.hasOwnProperty.call(event, "trackerId")) {
      if (event.trackerId) {
        onSubmit(event);
      }
    } else {
      if (
        Object.prototype.hasOwnProperty.call(event, "from") &&
        Object.prototype.hasOwnProperty.call(event, "to")
      ) {
        onSubmit(event);
      }
    }
  };

  return (
    <>
      <form
        onSubmit={handleSubmit(event => {
          onSubmitEvent(event);
        })}
      >
        <div className="flex w-[450px] flex-col gap-2 p-2 ">
          {activeFilters.map(
            (filter: any, index: number) =>
              (filter === "singleDate" && (
                <NeoDatePicker
                  label="Date"
                  handleDateChange={onSingleDateChange}
                  value={defaultSingleDate}
                />
              )) ||
              (filter === "date" && (
                <>
                  <NeoSelect
                    name="filterType"
                    label="Filter Type"
                    selectedKeys={[selectedFilterType]}
                    onSelectionChange={keys => {
                      const value = Array.from(keys)[0];
                      if (!value) return;
                      const nextValue = String(value);
                      setSelectedFilterType(nextValue);
                      setShowDateRange(false);
                      handleFromToFilterData(nextValue);
                      setValue("filterType", nextValue);
                    }}
                    className="w-[50%]"
                    size="md"
                  >
                    {reportFilterConfig?.mainFilter?.map(item => (
                      <SelectItem key={item.value} value={item.value}>
                        {item.label}
                      </SelectItem>
                    ))}
                  </NeoSelect>
                  {showDateRange && (
                    <NeoDatePicker
                      type="range"
                      label="Date Range"
                      handleDateChange={onDateChange}
                      rangedefaultValue={selectedDateRange}
                    />
                  )}
                </>
              )) ||
              (filter === "vehicle" && (
                <NeoSelect
                  {...register("trackerId")}
                  label="Vehicle"
                  selectionMode="multiple"
                  defaultSelectedKeys={[defaultVehicleMultiple]}
                >
                  {vehicles.map(item => (
                    <SelectItem key={item.trackerId} value={item.trackerId}>
                      {item.trackerName}
                    </SelectItem>
                  ))}
                </NeoSelect>
              )) ||
              (filter === "vehicleSingle" && (
                <NeoSelect
                  {...register("trackerId")}
                  label="Vehicle"
                  defaultSelectedKeys={[defaultVehicleSingle]}
                >
                  {vehicles.map(item => (
                    <SelectItem key={item.trackerId} value={item.trackerId}>
                      {item.trackerName}
                    </SelectItem>
                  ))}
                </NeoSelect>
              )) ||
              //threshold
              (filter === "threshold" && (
                <>
                  <NeoSelect
                    {...register("threshold")}
                    label="Threshold Type"
                    defaultSelectedKeys={[defaultThreshold]}
                    //onChange={handleFilterTypeChange}
                  >
                    {reportFilterConfig?.thresholdList?.map(item => (
                      <SelectItem key={item.value} value={item.value}>
                        {item.label}
                      </SelectItem>
                    ))}
                  </NeoSelect>
                </>
              )) ||
              //tripStatus
              (filter === "tripStatus" && (
                <>
                  <NeoSelect
                    multiple={true}
                    {...register("status")}
                    label="Trip status Type"
                    defaultSelectedKeys={tripTypeStatussetDropdown}
                    //onChange={handleFilterTypeChange}
                  >
                    {reportFilterConfig?.tripStatus?.map(item => (
                      <SelectItem key={item.value} value={item.value}>
                        {item.label}
                      </SelectItem>
                    ))}
                  </NeoSelect>
                </>
              ))
          )}
          {innerFilters?.map((filter: any) => (
            <div key={filter.uid} className="mb-4">
              <h3 className="mb-2 text-sm font-semibold">{filter.label}</h3>
              <div className="flex flex-wrap gap-2">
                {filter.options.map((opt: any) => {
                  const isSelected = selectedFilters[filter.uid]?.includes(
                    opt.id
                  );

                  return (
                    <div key={opt.id}>
                      {filter.type === "multiSelect" && (
                        <Chip
                          color={isSelected ? "primary" : "default"}
                          onClick={() => toggleMultiSelect(filter.uid, opt.id)}
                          className="cursor-pointer"
                        >
                          {opt.name}
                        </Chip>
                      )}
                      {filter.type === "switch" && (
                        <Switch
                          isSelected={isSelected}
                          onChange={e =>
                            toggleSwitch(filter.uid, opt.id, e.target.checked)
                          }
                          size="md"
                        >
                          {opt.name}
                        </Switch>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
          <div className="w-100 flex justify-end">
            <NeoButton
              type="submit"
              color="yellow"
              className="gap-[5px] text-lg"
              startContent={
                <Image
                  className="h-5 w-5"
                  src="/icons/filter.svg"
                  alt="filter"
                />
              }
            >
              Filter
            </NeoButton>
          </div>
        </div>
      </form>
    </>
  );
};
